import { Text } from "monday-ui-react-core";
interface Props {
  context: any;
}
const FormOperationCounter: React.FC<Props> = ({ context }) => {
  return (
    <div className="w-4/5 mx-auto mb-12">
      {context?.operation_link?.length ? (
        <iframe
          src={context?.operation_link}
          title="operation counter"
          className="w-full h-screen border-0"
        />
      ) : (
        // <div className="w-4/5 mx-auto">
        <Text color={Text.colors.PRIMARY} type={Text.types.TEXT2}>
          We cannot find your Operation Counter information. Please contact our
          support center for futher assistance at{" "}
          <a href="mailto: support@b-lab.app"> support@b-lab.app </a>.
        </Text>
        // </div>
      )}
    </div>
  );
};

export default FormOperationCounter;
